import { computed } from "vue"

import { useMoveWithUsRecord } from "@/views/myaccount/moving-home/useMoveWithUsRecord"

import { useMoveOutTimeline } from "./useMoveOutTimeline"

export const useMoveOutScheduled = () => {
  const timeline = useMoveOutTimeline()
  const moveWithUs = useMoveWithUsRecord()

  // A Move With Us submit books a move-out too, so its record wins.
  const isMoveOutScheduled = computed(
    () => timeline.isBooked.value && moveWithUs.hasNoRecord.value,
  )

  const isLoading = computed(
    () => timeline.isLoading.value || moveWithUs.isLoading.value,
  )

  return { isMoveOutScheduled, isLoading }
}
